import { NavBarItem, NavBarItemProps } from "./navbar";
import React from "react";
import {} from "@me8eon/selection_button";
import { useCommonComponents } from "@me8eon/components";


export const DefaultNavItem = (prefix: string): NavBarItem =>
    ({ value, selectedOps }: NavBarItemProps) => {
        const { SelectableButton } = useCommonComponents();
        return <SelectableButton rootId={prefix} selectedOps={selectedOps} text={value} />;
    };


